import React, { useState } from "react";
// import {
//   AlertCircle,
//   Building2,
//   MapPin,
//   Wallet,
//   FileText,
//   X,
// } from "lucide-react";

import { PlusCircleOutlined } from "@ant-design/icons";

import "./KYCForm.scss";

const KYCForm = () => {
  const [formData, setFormData] = useState({
    kycType: "",
    gstNumber: "",
    otp: "",
    businessType: "Public Limited",
    companyName: "",
    panNumber: "",
    tanNumber: "",
    pincode: "",
    state: "",
    businessAddress: "",
    accountNumber: "",
    ifscCode: "",
    gstCertificate: null,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFormData((prev) => ({
        ...prev,
        gstCertificate: !e.target.files[0],
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form Data:", formData);
  };

  return (
    <div className="kyc-container">
      <div className="kyc-form-wrapper">
        <div className="kyc-header">
          <PlusCircleOutlined size={20} className="header-icon" />
          <div>
            <h2>KYC Verification</h2>
            <p>Please complete your KYC verification</p>
          </div>
          <button className="close-button">
            <PlusCircleOutlined size={18} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="kyc-form">
          <div className="form-section">
            <h3>
              <PlusCircleOutlined size={16} className="section-icon" />
              KYC Type
            </h3>
            <div className="form-group">
              <label>Select KYC Type</label>
              <select
                name="kycType"
                value={formData.kycType}
                onChange={handleInputChange}
                required
              >
                <option value="">Choose verification type</option>
                <option value="driving">Driver License</option>
                <option value="aadhar">Aadhar Card</option>
              </select>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>GST Number</label>
                <input
                  type="text"
                  name="gstNumber"
                  value={formData.gstNumber}
                  onChange={handleInputChange}
                  placeholder="Enter GST Number"
                />
              </div>
              <div className="form-group">
                <label>OTP</label>
                <input
                  type="text"
                  name="otp"
                  value={formData.otp}
                  onChange={handleInputChange}
                  placeholder="Enter OTP"
                />
              </div>
            </div>
          </div>

          <div className="form-section">
            <h3>
              <PlusCircleOutlined size={16} className="section-icon" />
              Business Details
            </h3>
            <div className="form-row">
              <div className="form-group">
                <label>Type of Business</label>
                <select
                  name="businessType"
                  value={formData.businessType}
                  onChange={handleInputChange}
                >
                  <option value="Public Limited">Public Limited</option>
                  <option value="Private Limited">Private Limited</option>
                </select>
              </div>
              <div className="form-group">
                <label>Company Name</label>
                <input
                  type="text"
                  name="companyName"
                  value={formData.companyName}
                  onChange={handleInputChange}
                  placeholder="Enter company name"
                />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>PAN Number</label>
                <input
                  type="text"
                  name="panNumber"
                  value={formData.panNumber}
                  onChange={handleInputChange}
                  placeholder="Enter PAN number"
                />
              </div>
              <div className="form-group">
                <label>TAN Number</label>
                <input
                  type="text"
                  name="tanNumber"
                  value={formData.tanNumber}
                  onChange={handleInputChange}
                  placeholder="Enter TAN number"
                />
              </div>
            </div>
          </div>

          <div className="form-section">
            <h3>
              <PlusCircleOutlined size={16} className="section-icon" />
              Address Details
            </h3>
            <div className="form-row">
              <div className="form-group">
                <label>Pincode</label>
                <input
                  type="text"
                  name="pincode"
                  value={formData.pincode}
                  onChange={handleInputChange}
                  placeholder="Enter pincode"
                />
              </div>
              <div className="form-group">
                <label>State</label>
                <input
                  type="text"
                  name="state"
                  value={formData.state}
                  onChange={handleInputChange}
                  placeholder="Enter state"
                />
              </div>
            </div>

            <div className="form-group">
              <label>Business Address</label>
              <input
                type="text"
                name="businessAddress"
                value={formData.businessAddress}
                onChange={handleInputChange}
                placeholder="Enter business address"
              />
            </div>
          </div>

          <div className="form-section">
            <h3>
              <PlusCircleOutlined size={16} className="section-icon" />
              Bank Details
            </h3>
            <div className="form-row">
              <div className="form-group">
                <label>Account Number</label>
                <input
                  type="text"
                  name="accountNumber"
                  value={formData.accountNumber}
                  onChange={handleInputChange}
                  placeholder="Enter account number"
                />
              </div>
              <div className="form-group">
                <label>IFSC Code</label>
                <input
                  type="text"
                  name="ifscCode"
                  value={formData.ifscCode}
                  onChange={handleInputChange}
                  placeholder="Enter IFSC code"
                />
              </div>
            </div>
          </div>

          <div className="form-section">
            <h3>
              <PlusCircleOutlined size={16} className="section-icon" />
              GST Certificate
            </h3>
            <div className="form-group file-upload">
              <label className="file-label">
                <input
                  type="file"
                  onChange={handleFileChange}
                  accept=".pdf,.jpg,.jpeg,.png"
                />
                <span className="upload-button">Upload Certificate</span>
              </label>
              {formData.gstCertificate && (
                <span className="file-name">
                  {formData.gstCertificate.name}
                </span>
              )}
            </div>
          </div>

          <button type="submit" className="submit-button">
            Submit KYC
          </button>
        </form>
      </div>
    </div>
  );
};

export default KYCForm;
